import { Dialog, IconButton } from '@montugroup/design-system';
import {
  dialogActionsClasses,
  dialogClasses,
  dialogContentClasses,
  dialogContentTextClasses,
  dialogTitleClasses,
  styled,
} from '@mui/material';

// from the designs (consultation-waitlist-design.html)
const WAITLIST_DIALOG_MAX_WIDTH_PX = 500;

// The waitlist modal from the designs: a card with 32px padding, so the title, content and actions drop MUI's own
// padding. The leave dialog uses it too, so the two match.
export const WaitlistDialog = styled(Dialog)(({ theme }) => ({
  [`& .${dialogClasses.paper}`]: {
    position: 'relative',
    width: '90%',
    maxWidth: WAITLIST_DIALOG_MAX_WIDTH_PX,
    maxHeight: '90vh',
    margin: 0,
    padding: theme.spacing(8),
    borderRadius: theme.spacing(3),
  },
  [`& .${dialogTitleClasses.root}`]: {
    // clear of the close button
    padding: theme.spacing(0, 8, 0, 0),
    marginBottom: theme.spacing(3),
    fontSize: '1.375rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: theme.palette.text.primary,
  },
  [`& .${dialogContentClasses.root}`]: {
    padding: 0,
  },
  [`& .${dialogContentTextClasses.root}`]: {
    fontSize: theme.typography.body2.fontSize,
    lineHeight: 1.5,
    color: theme.palette.text.primary,
  },
  [`& .${dialogActionsClasses.root}`]: {
    padding: 0,
    marginTop: theme.spacing(6),
    gap: theme.spacing(3),
  },
}));

// 16px from the corner, with the icon button's own padding as the touch target
export const DialogCloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  color: theme.palette.text.primary,
}));
